import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { Separator } from "../ui/separator";
import { User, Save } from "lucide-react";
import { toast } from "sonner";
import { useApi } from "./useApi";

export function ProfileSettings({ user, token, t, checkAuth }) {
  var [form, setForm] = useState({ name: user?.name || "" });
  var [loading, setLoading] = useState(false);
  var { putJson } = useApi(token);

  async function handleSave() {
    setLoading(true);
    try {
      var response = await putJson("/api/users/" + user.user_id, { name: form.name });
      if (response.ok) {
        toast.success(t("settings.profileUpdated"));
        await checkAuth();
      } else {
        var error = await response.json();
        toast.error(error.detail || t("common.error"));
      }
    } catch (err) {
      toast.error(t("common.error"));
    } finally {
      setLoading(false);
    }
  }

  return (
    <Card className="bento-card" data-testid="profile-settings-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><User className="w-5 h-5" />{t("settings.profile")}</CardTitle>
        <CardDescription>{t("settings.yourPersonalInfo")}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center gap-4">
          <Avatar className="w-16 h-16">
            <AvatarImage src={user?.picture} />
            <AvatarFallback className="bg-primary text-primary-foreground text-xl">{user?.name?.charAt(0)?.toUpperCase()}</AvatarFallback>
          </Avatar>
          <div>
            <p className="font-semibold text-lg">{user?.name}</p>
            <p className="text-sm text-muted-foreground">{user?.email}</p>
          </div>
        </div>
        <Separator />
        <div className="space-y-4">
          <div>
            <Label htmlFor="name" className="form-label">{t("settings.displayName")}</Label>
            <Input id="name" value={form.name} onChange={function(e) { setForm({ ...form, name: e.target.value }); }} placeholder={t("common.name")} data-testid="settings-name-input" />
          </div>
          <div>
            <Label className="form-label">{t("common.email")}</Label>
            <Input value={user?.email || ""} disabled className="bg-muted" />
            <p className="text-xs text-muted-foreground mt-1">{t("settings.emailCannotChange")}</p>
          </div>
          <Button onClick={handleSave} disabled={loading} data-testid="settings-save-btn">
            <Save className="w-4 h-4 mr-2" />{loading ? t("settings.saving") : t("settings.saveChanges")}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
